import { tokens } from "../../tokens";

export const spinnerBase = {
  borderRadius: "50%",
  border: "4px solid transparent",
  borderTop: `4px solid ${tokens.color.primary.base}`,
  animation: "spin 1s linear infinite",
};

export const spinnerSizes = {
  sm: { width: tokens.size.sm, height: tokens.size.sm },
  md: { width: tokens.size.md, height: tokens.size.md },
  lg: { width: tokens.size.lg, height: tokens.size.lg },
};

export const spinnerVariants = {
  default: { borderTopColor: tokens.color.primary.base },
  success: { borderTopColor: tokens.color.feedback.success },
  error: { borderTopColor: tokens.color.feedback.error },
  warning: { borderTopColor: tokens.color.feedback.warning },
  info: { borderTopColor: tokens.color.feedback.info },
};

export const loadingSpinnerKeyframes = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;
